<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRefreshVisible="false" @refresh="onRefresh">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data dal</label>
                        <date-picker v-model="filtroMovimentiContabili.dataDal" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data al</label>
                        <date-picker v-model="filtroMovimentiContabili.dataAl" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>
                </b-row>
            </b-form>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                    <b-button type="submit" variant="info" @click="onSubmit">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                    <b-button type="reset" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                </b-col>
            </b-row>
        </template>

        <template slot="table-body">
            <rsa-paziente-movimenti-contabili-list-component ref="cmpRsaPazienteMovimentiContabiliList"></rsa-paziente-movimenti-contabili-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteMovimentiContabiliListComponent from "../../rsapaziente/components/RsaPazienteMovimentiContabiliListComponent.vue";
import DatePicker from "vue2-datepicker";

export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteMovimentiContabiliListComponent,
        DatePicker,
    },
    data() {
        return {
            idAccettazione: null,
            btnBackVisible: true,
            pathResource: null,
            linkedit: null,
            linkback: "/rsagestioneospiti",
            pathResourceAccettazione: "/accettazioni",
            showModalLoading: false,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
            filtroMovimentiContabili: {},
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroMovimentiContabili"]) {
            me.filtroMovimentiContabili = JSON.parse(sessionStorage["filtroMovimentiContabili"]);
        }
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaPazienteMovimentiContabiliList.loadData(me.idAccettazione);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onRefresh() {
            this.loadAccettazione();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroMovimentiContabili"] = JSON.stringify(me.filtroMovimentiContabili);

            me.$refs.cmpRsaPazienteMovimentiContabiliList.loadData(me.idAccettazione);
        },
        onReset() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.filtroMovimentiContabili = { dataDal: null, dataAl: null };
            sessionStorage["filtroMovimentiContabili"] = JSON.stringify(me.filtroMovimentiContabili);
            me.$refs.cmpRsaPazienteMovimentiContabiliList.loadData(me.idAccettazione);
        },
    },
};
</script>
